export default __webpack_public_path__ + "07d931367ad146b2df8a480791f35190.png";